import { styled } from "goober";
import { type AppTag, tagManifest } from "../../../shared/connectors/tags";
import { useMakeUrl, routes, useCurrentUrl } from "../../lib/urls";
import { Icon } from "../Icon";
import { Link } from "../Link";
import { Text } from "../Text";

const Container = styled("div")`
  border-bottom: 0.5px solid var(--border-alpha);
  overflow: hidden;
  position: relative;
  display: flex;
  align-items: center;
`;

const TagsContainer = styled("div")`
  flex: 1;
  width: 0;
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: auto;
  scrollbar-width: none;
  padding: 8px 24px 8px 12px;

  &::-webkit-scrollbar {
    display: none;
  }

  &:after {
    content: "";
    display: block;
    width: 24px;
    background: linear-gradient(
      to right,
      var(--transparent),
      var(--surface-primary)
    );
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
  }
`;

const Tag = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  border-radius: 24px;
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    background: var(--alpha4);
  }
`;

type Props = {
  tags: AppTag[];
};

export function DirectoryTabs({ tags }: Props) {
  const makeUrl = useMakeUrl();
  const { tag: selectedTag } = useCurrentUrl(routes.connectors.library);

  return (
    <Container>
      <TagsContainer>
        {(["all", ...tags.filter((t) => t !== "featured")] as const).map(
          (tag) => {
            const iconName = tag === "all" ? "layers" : tagManifest[tag].icon;
            return (
              <Tag
                key={tag}
                to={makeUrl(routes.connectors.library, { tag, q: "" })}
                replace
                style={{
                  color:
                    selectedTag === tag
                      ? "var(--text-primary)"
                      : "var(--text-secondary)",
                  backgroundColor:
                    selectedTag === tag ? "var(--alpha4)" : undefined,
                }}
              >
                <Icon name={iconName} size={16} />
                <Text variant="text-small-md">
                  {tag === "all" ? "All" : tagManifest[tag].label}
                </Text>
              </Tag>
            );
          }
        )}
      </TagsContainer>
    </Container>
  );
}
